import { AuditActorSchema } from '@/entities/common/Actor'
import { z } from '@/utils/zod'

export const BaseEntitySchema = z.object({
    _id: z.objectId(),
    createdAt: z.isoDateTime.nullish(),
    updatedAt: z.isoDateTime.nullish(),
    removedAt: z.isoDateTime.nullish(),
    createdBy: AuditActorSchema.or(z.string()).nullish(),
    updatedBy: AuditActorSchema.or(z.string()).nullish(),
    removedBy: AuditActorSchema.or(z.string()).nullish(),
    __ignoreTriggers: z.string().nullish(),
})

export type BaseEntity = z.infer<typeof BaseEntitySchema>

export const EntitySchema = BaseEntitySchema.extend({
    createdBy: AuditActorSchema.nullish(),
    updatedBy: AuditActorSchema.nullish(),
    removedBy: AuditActorSchema.nullish(),
})

export type Entity = z.infer<typeof EntitySchema>

export const OldEntitySchema = BaseEntitySchema.extend({
    createdBy: z.string().nullish(),
    updatedBy: z.string().nullish(),
    removedBy: z.string().nullish(),
})

export type OldEntity = z.infer<typeof OldEntitySchema>

export const OrganizationEntitySchema = EntitySchema.extend({
    organization: z.objectId(),
})

export type OrganizationEntity = z.infer<typeof OrganizationEntitySchema>

export const MandateEntitySchema = OrganizationEntitySchema.extend({
    mandate: z.objectId(),
})

export type MandateEntity = z.infer<typeof MandateEntitySchema>

export const MultiMandateEntitySchema = OrganizationEntitySchema.extend({
    mandates: z.array(z.objectId()),
})

export type MultiMandateEntity = z.infer<typeof MultiMandateEntitySchema>
